import React, { useState, useContext } from "react";
import AddTrainer from '../components/Trainer/AddTrainer';
import AuthContext from "../AuthContext";
import UpdateTrainer from '../components/Trainer/UpdateTrainer';
import AllTrainer from '../components/Trainer/AllTrainer';
import TrainerDetails from '../components/Trainer/TrainerDetails';

function Inventory() {
  const [showProductModal, setShowProductModal] = useState(false);
  const [updatePage, setUpdatePage] = useState(true);
  const [updateProduct, setUpdateProduct] = useState([]);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [detailsShow, setDetailsShow] = useState(false);
  const [detail, setDetail] = useState([]);

  const authContext = useContext(AuthContext);

  const updateProductModalSetting = (selectedProductData) => {
    setUpdateProduct(selectedProductData);
    setShowUpdateModal(!showUpdateModal);
  };

  const addProductModalSetting = () => {
    setShowProductModal(!showProductModal);
  };

  const details = (selectedProductData) => {
    setDetail(selectedProductData);
    setDetailsShow(!detailsShow);
  };

  const handlePageUpdate = () => {
    setUpdatePage(!updatePage);
  };

  return (
    <div className="col-span-12 lg:col-span-10 flex justify-center">
      <div className="flex flex-col gap-5 w-11/12">
        
        {/* Add Trainer Modal */}
        {showProductModal && (
          <AddTrainer
            addProductModalSetting={addProductModalSetting}
            handlePageUpdate={handlePageUpdate}
          />
        )}

        {/* Update Trainer Modal */}
        {showUpdateModal && (
          <UpdateTrainer
            updateProductData={updateProduct}
            handlePageUpdate={handlePageUpdate}
            updateModalSetting={updateProductModalSetting}
          />
        )}

        {/* Trainer Details Modal */}
        {detailsShow && (
          <TrainerDetails
            detail={detail}
            closeDetails={() => setDetailsShow(false)}
          />
        )}

        {/* Table */}
        <div className="overflow-x-auto rounded-md bg-white border border-gray-200 shadow-lg">
          <div className="flex justify-between p-4 bg-gray-100 border-b border-gray-200">
            <h2 className="font-bold text-lg text-gray-700">Trainer</h2>
            <div className="flex gap-4">
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 text-sm rounded-sm shadow-md transition duration-300"
                onClick={addProductModalSetting}
              >
                Add New Trainer
              </button>
            </div>
          </div>
          <AllTrainer 
            updateProductModalSetting={updateProductModalSetting} 
            handlePageUpdate={handlePageUpdate}
            showDetails={details}
          />
        </div>
      </div>
    </div>
  );
}

export default Inventory;
